import React, { useId } from "react"
import clsx from "clsx"
import { useField } from "formik"
import S from "./quantity-input.module.scss"
import MinusIcon from "../svgs/minus.svg"
import PlusIcon from "../svgs/plus.svg"

type Props = {
  label: string
  name: string
  partial?: boolean
}

const QuantityInput: React.FC<Props> = ({
  label,
  name,
  partial = false,
  ...props
}) => {
  const [field, meta, helpers] = useField({ name, ...props })
  const id = useId()
  const handleAdd = async () => {
    const value = Number(field.value || 1)
    await helpers.setValue(value + 1)
  }

  const handleSubtract = async () => {
    const value = Number(field.value || 1)

    if (value > 1) {
      await helpers.setValue(value - 1)
    }
  }

  return (
    <>
      {label && (
        <label
          htmlFor={id}
          className={clsx({ "text-danger": meta.error && meta.touched })}
        >
          {label}
        </label>
      )}
      <div className="input-group">
        <button
          className={clsx("btn", S.button)}
          type="button"
          onClick={handleSubtract}
          aria-label="Remove 1"
        >
          <MinusIcon />
        </button>
        <input
          className={clsx("form-control", S.input, {
            "is-invalid": meta.error && meta.touched,
          })}
          id={id}
          type="number"
          step={partial ? 0.1 : 1}
          min={partial ? 1.0 : 1}
          {...field}
          {...props}
        />
        <button
          className={clsx("btn", S.button)}
          type="button"
          onClick={handleAdd}
          aria-label="Add 1"
        >
          <PlusIcon />
        </button>
      </div>
      {meta.touched && meta.error && (
        <span className="invalid-feedback d-inline-block">{meta.error}</span>
      )}
    </>
  )
}

export default QuantityInput
